module.exports = "/assets/data/5ba0b0c6cb6cab953310054459369c16-BB6.data.json";